module.exports = __webpack_public_path__ + "static/img/gaozhongdili3.81771106.jpg";